
import { Action, Getter, namespace } from "vuex-class"
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
// @ts-ignore
import vSelect from "vue-select"
import { DayOfWeek } from "@/types/view"
import { FirstDayOfWeekSetting } from "@/types/tenantSetting"
@Component({
	components: {
		"v-select": vSelect
	}
})
export default class DayOfWeekSetting extends Vue {
	@Prop()
	firstDayOfWeekSetting!: FirstDayOfWeekSetting

	DayOfWeek = DayOfWeek

	enabled: boolean = false
	dayOfWeekSelected: string = "Monday"

	key: string = ""

	mounted () {
		this.enabled = this.firstDayOfWeekSetting.enabled
		this.dayOfWeekSelected = this.DayOfWeek[this.firstDayOfWeekSetting.dayOfWeekSelected]
	}

	private get daysOfWeekNames (): string[] {
		return Object.values(DayOfWeek).filter(value => typeof value === "string") as string[]
	}

	private onSelected (dayOfWeekSelected: string) {
		this.dayOfWeekSelected = dayOfWeekSelected

		const model: FirstDayOfWeekSetting = {
			enabled: this.enabled,
			dayOfWeekSelected: (this.DayOfWeek as any)[this.dayOfWeekSelected]
		}
		this.$emit("input", model)
	}

	private onEnableChange () {
		this.enabled = !this.enabled
		this.dayOfWeekSelected = "Monday"

		const model: FirstDayOfWeekSetting = {
			enabled: this.enabled,
			dayOfWeekSelected: DayOfWeek.Monday
		}
		this.$emit("input", model)
	}
}
